import { NimmstaLayout } from './NimmstaLayout';
const LAYOUT = `<?xml version="1.0" encoding="utf-8"?>
<NimmstaLayout name="Counter Layout">
    <device width="1.54" height="1.54" pxx="200" pxy="200">
        <screen default="true" name="default">
            <staticElements>
                <statusbar />
                <cell x="15" y="40" horizontalAlignment="left" fontSize="34pt">ANZ:</cell>
                <cell x="100" y="40" width="70" horizontalAlignment="right" fontSize="34pt" name="count">0</cell>
                <button x="0" y="100" type="plain" horizontalAlignment="center" width="65" height="50" name="increment1">+ 1</button>
                <button x="67" y="100" type="plain" horizontalAlignment="center" width="65" height="50" name="increment5">+ 5</button>
                <button x="134" y="100" type="plain" horizontalAlignment="center" width="65" height="50" name="increment10">+ 10</button>
                <button x="0" y="150" type="plain" horizontalAlignment="center" width="65" height="50" name="decrement1">- 1</button>
                <button x="67" y="150" type="plain" horizontalAlignment="center" width="65" height="50" name="decrement5">- 5</button>
                <button x="134" y="150" type="plain" horizontalAlignment="center" width="65" height="50" name="decrement10">- 10</button>
            </staticElements>
        </screen>
    </device>
</NimmstaLayout>`;
export class CounterLayout extends NimmstaLayout {
    constructor(count) {
        super(LAYOUT, { count });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ291bnRlckxheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2xheW91dHMvQ291bnRlckxheW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFaEQsTUFBTSxNQUFNLEdBQUc7Ozs7Ozs7Ozs7Ozs7Ozs7O2lCQWlCRSxDQUFDO0FBS2xCLE1BQU0sT0FBTyxhQUFjLFNBQVEsYUFBYTtJQUM5QyxZQUFZLEtBQWE7UUFDdkIsS0FBSyxDQUFDLE1BQU0sRUFBRSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFDM0IsQ0FBQztDQUNGIn0=